var path = 'areas/projects/action-template-fields/field-Select.html';
var html = "<div> <div style=position:absolute>{{vm.placeholder}}</div> <select class=form-control ng-model=vm.value ng-options=\"option.Value as option.DisplayText for option in vm.getSelectOptions()\"> </select> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/action-template-fields/field-Select.html
// module id = 2789001176268774
// module chunks = 1